<div class="row">
    <div class="col-lg-8">
        <app-incentive-cards></app-incentive-cards>
    </div>
    <div class="col-lg-4">
        <div class="row">
            <div class="col-sm-6 col-lg-12">
                <app-incentive-performance></app-incentive-performance>
            </div>
            <div class="col-sm-6 col-lg-12">
                <app-yearly-performance></app-yearly-performance>
            </div>
        </div>
    </div>
</div>


<div class="row">
    <div class="col-lg-4">
        <div class="row">
            <div class="col-sm-6 col-lg-12">
                <app-distribution-performance />
            </div>
            <div class="col-sm-6 col-lg-12">
                <app-yearly-distribution-performance />
            </div>
        </div>
    </div>
    <div class="col-lg-8">
        <app-distribution-cards />
    </div>
</div>


<app-main-cer-cards />

<br><br><br>